import React, { Fragment, useContext, useEffect, useState } from "react";
import TopicSvgIcon from "../../../Svg/TopicSvgIcon";
import AlertContext from "../../../context/AlertContext";
import { useParams, useLocation } from 'react-router-dom';
import Tooltip from "../../CommonComponents/Tooltip";
import constants from "../../../constants";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";

const CcSection = ({ data }) => {
  const { idHash, username } = useParams();
  const { pathname } = useLocation();
  const Alert = useContext(AlertContext);
  const {
    setTopic,
    navigate,
    setStatus,
    setIsLoaded,
    setTestData,
    setShowNotify,
    setCodingTestData,
    setShowInstruction,
  } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const [stats,setStats] = useState([]);

  useEffect(()=>{
    const parsedData =JSON.parse(data.complexity) ?? [];
    const orderWise = parsedData.sort((a,b) => a.complexityId-b.complexityId);
    // console.log("orderWise:",orderWise);
    setStats(orderWise ?? []);
  },[data.complexity]);

  const prepareTestData = (questionData, overrides = {}) => {
    return {
      ...questionData,
      ...overrides,
      single: true,
      instruction: null,
      testmode: constants.MODE.PRACTICE_MODE,
      status: constants.QUESTION_STATUS.ASSIGNED,
      proctored: constants.PROCTORING_MODE.NONE,
      testtype: constants.libTypeIds.CODING_CHALLENGE,
      configdata: {
        languageid: questionData.languageid,
      },
    };
  };

  const fetchSecQuestions = async () => {
    setIsLoaded(true);

    try {
      const response = await axios.get(
        `node/learner/cc/section/${data.id}/question?page=1&limit=1&cid=null&name=&random=true&qns=true`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );

      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        const questions = response.data.data.questions || [];

        if (!questions.length) {
          setShowNotify({
            show: true,
            title: "Explore Another Category !!",
            msg: "There are no more questions to display in this section for now. More challenges await elsewhere!",
          });
          return;
        }

        const randomQuestion = {
          ...questions[0],
          random: true,
        };
        const testData = prepareTestData(randomQuestion);

        sessionStorage.setItem("ccSecName", data.name);
        sessionStorage.setItem("ccSecId", data.id);
        setTestData(testData);
        Alert.setCurrentStep(0);
        setCodingTestData(testData);
        setShowInstruction(true);
        setStatus(constants.QUESTION_STATUS.ASSIGNED);
        setTopic({ id: testData.secid, name: testData.secname });
        navigate("/instruction");
      } else {
        setShowNotify({
          show: true,
          title: "Error!",
          msg: "Something went wrong. Please try again later or contact support.",
        });
      }
    } catch (error) {
      useCommonFunctionHks.getCatchBlockDetails(error);
    } finally {
      setIsLoaded(false);
    }
  };
  
  // console.log("data:",data,"stats:",stats,stats.length);
  
  return (
    <div
      className="ccSecContainer"
      onClick={(e) => {
        e.stopPropagation();
        (pathname.includes("/u/"))
          ? Alert.navigate(`/u/${idHash}/${username}/cc/section/${data.name}`)
          : Alert.navigate(`/main/cc/section/${data.id}`);
        sessionStorage.setItem("ccSecName", data.name);
        sessionStorage.setItem("ccSecId", data.id);
      }}
    >
      <div className="ccSecContent">
        <div className="ccSecContent-1">
          <TopicSvgIcon icon={data.id} />
          <div className="ccSecContentText">{data.name}</div>
        </div>
        <Tooltip placement="top" title="Pick One" theme="light">
          <div className="ccSecContent-2"
            onClick={(e) => {
              e.stopPropagation();
              fetchSecQuestions();
              sessionStorage.setItem("ccSecName", data.name);
              sessionStorage.setItem("ccSecId", data.id);
            }} 
          >
            <TopicSvgIcon icon={0}   
            />
          </div>
        </Tooltip>
      </div>
      <div className="ccSecInfoContainer">
        {stats && stats?.map((item, index) => (
          <Fragment key={index}>
            <div key={index} className={`categoryItem`}>
              {item?.solvedCount ?? 0}/{item?.totalCount ?? 0} <br />
            <span className="categoryItemName">{item?.complexityName}</span>
            </div>
            {index !== stats.length - 1 && (
              <hr />
            )}
          </Fragment>
        ))}
      </div>
      {/* <svg
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        className="ccSecLeftChevron"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeWidth="2"
          stroke="#667085"
          d="M9 18L15 12L9 6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg> */}
    </div>
  );
};

export default CcSection;
